var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 5C8.19599 5 7.73149 5 7.34283 5.06156C5.20337 5.40042 3.52542 7.07837 3.18656 9.21783C3.125 9.60649 3.125 10.071 3.125 11V13C3.125 15.8003 3.125 17.2004 3.66997 18.27C4.14933 19.2108 4.91424 19.9757 5.85505 20.455C6.92461 21 8.32474 21 11.125 21H13.125C15.9253 21 17.3254 21 18.395 20.455C19.3358 19.9757 20.1007 19.2108 20.58 18.27C21.125 17.2004 21.125 15.8003 21.125 13V11C21.125 10.071 21.125 9.60649 21.0634 9.21783C20.7246 7.07837 19.0466 5.40042 16.9072 5.06156C16.5185 5 16.054 5 15.125 5M9.125 5V6.5M9.125 5V3M9.125 5H15.125M15.125 5V3M15.125 5V6.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 10H17.125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.5H8.635M12.125 13.5H12.135M15.625 13.5H15.635M8.625 16.5H8.635M12.125 16.5H12.135M15.625 16.5H15.635",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutlined);
export default __webpack_public_path__ + "static/media/calendar_outlined.1a267d4a90d5be191d8d6ec1f9ff7c13.svg";
export { ForwardRef as ReactComponent };